import { render, staticRenderFns } from "./DashboardUsuarios.vue?vue&type=template&id=3bbbcb48&"
import script from "./DashboardUsuarios.vue?vue&type=script&lang=js&"
export * from "./DashboardUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUsuarios.vue?vue&type=style&index=0&id=3bbbcb48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports